// extracted by mini-css-extract-plugin
module.exports = {"App":"style_App__G1ee_","content":"style_content__wVsZu","pepe":"style_pepe__1kJYw"};